// extracted by css-extract-rspack-plugin
export default {"AlertModalsBorder":"n6XNt","AlertModalsTextWidth":"Ys1SB"};